module.exports = __webpack_public_path__ + "img/github.c39c85a1.png";